import { render, staticRenderFns } from "./WebServiceConfigurationForm.vue?vue&type=template&id=5853eb5c&"
import script from "./WebServiceConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./WebServiceConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5853eb5c')) {
      api.createRecord('5853eb5c', component.options)
    } else {
      api.reload('5853eb5c', component.options)
    }
    module.hot.accept("./WebServiceConfigurationForm.vue?vue&type=template&id=5853eb5c&", function () {
      api.rerender('5853eb5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/WebServiceConfigurationForm.vue"
export default component.exports